import React, { useState, useRef } from "react";
import { Col, Container, Card, Row } from "reactstrap";
import BookingModal from '../component/organisms/BookingModal';
import EPaycoButton from '../component/EPaycoButton';
import { crearReserva } from '../services/payloadService';
import parseHtml from '../utils/parseHtml';
import { getPayloadMedia } from "../services/payloadService";

// Constante para conversión de precios
const DIVISOR_PRECIO = 3850;

function ProductCard({ producto, textoBoton, textoMoneda, tituloCaracteristicas, allProducts, onBookingSubmit }) {


    const [varianteSeleccionada, setVarianteSeleccionada] = useState(
        producto.variantes && producto.variantes.length > 0 ? producto.variantes[0] : null
    );

    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    // Find the index of the selected variant
    const indiceVariante = producto.variantes?.findIndex(v => v.id === varianteSeleccionada?.id) || 0;

    const mappedProduct = varianteSeleccionada ? {
        id: producto.id,
        documentId: producto.documentId, 
        nombre: producto.nombre,
        descripcion: producto.descripcion,
        maxPersons: varianteSeleccionada.numPersonas || 1,
        priceUsd: varianteSeleccionada.precio || 0,
        priceCop: varianteSeleccionada.precio || 0,
        varianteSeleccionada: varianteSeleccionada,
        indiceVariante: indiceVariante,
    } : null;

    return (
        <Card className="border-0 shadow-sm rounded">
            {producto.imagen && (
                <div className="w-100 overflow-hidden rounded-top" style={{ aspectRatio: '16/9' }}>
                    <img 
                        src={getPayloadMedia(producto.imagen)} 
                        alt={producto.nombre} 
                        className="w-100 h-100"
                        style={{ objectFit: 'cover', display: 'block' }}
                    />
                </div>
            )}
            <div className="p-4 border-bottom border-light">
                
                <h6 className="fw-semibold mb-3 text-uppercase">{producto.nombre}</h6>
                <p className="text-muted mb-0">{parseHtml(producto.descripcion)}</p>

                {/* Variant selector */}
                {producto.variantes && producto.variantes.length > 0 && (
                    <div className="mt-3 mb-3">
                        <div className="d-flex gap-2 flex-wrap">
                            {producto.variantes.map((variante, idx) => (
                                <button
                                    key={idx}
                                    onClick={() => setVarianteSeleccionada(variante)}
                                    className={`btn ${varianteSeleccionada?.id === variante.id || varianteSeleccionada === variante ? 'btn-primary' : 'btn-outline-primary'} btn-sm`}
                                >
                                    {variante.nombreVariante || `${variante.numPersonas} ${variante.numPersonas === 1 ? 'Persona' : 'Personas'}`}
                                </button>
                            ))}
                        </div>
                    </div>
                )}
            <div className="d-flex flex-column my-4 ">
                <div className="d-flex ">
                    <span className="price text-body h3 fw-semibold mb-0">
                        ${varianteSeleccionada
                            ? (varianteSeleccionada.numPersonas > 1
                                ? Math.ceil(Math.ceil(varianteSeleccionada.precio / DIVISOR_PRECIO) / varianteSeleccionada.numPersonas).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })
                                : Math.ceil(varianteSeleccionada.precio / DIVISOR_PRECIO).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })
                              )
                            : '0'}
                    </span>
                    <span className="text-body align-self-end mb-1">{textoMoneda || '/COP'}</span>

                </div>
                <p className="text-body mb-0 fw-bold">Por persona</p>
                </div>
            {varianteSeleccionada?.stock > 0 ? (
                <button
                    onClick={handleOpenModal}
                    disabled={!varianteSeleccionada}
                    className={`btn ${producto.destacado ? 'btn-primary' : 'btn-outline-primary'} w-100`}
                >
                    {textoBoton || 'Reservar Ahora'}
                </button>
            ) : (
                <button
                    disabled={true}
                    className={`btn btn-outline-primary w-100`}
                >
                    Sold Out
                </button>
            )}
            </div>

            <div className="p-4">
            {producto.caracteristicas.length > 0 && (
                <>
                    <h6 className="mb-3">{tituloCaracteristicas || 'Features:'}</h6>
                <ul className="mb-0 list-unstyled">
                    
                    {producto.caracteristicas?.map((caracteristica, subkey) => (
                        <li className="text-body" key={subkey}>
                            <span className={caracteristica.incluido ? "text-[var(--color-success)] h5 me-1" : "text-danger h5 me-1"}>
                                <i className={caracteristica.incluido ? "uil uil-check-circle align-middle" : "uil uil-times-circle align-middle"}></i>
                            </span>
                            {parseHtml(caracteristica.texto)}
                        </li>
                    ))}
                </ul>
                </>
            )}
            </div>

            {/* Booking modal */}
            {mappedProduct && (
                <BookingModal
                    isOpen={isModalOpen}
                    onClose={handleCloseModal}
                    product={mappedProduct}
                    allProducts={allProducts || []}
                    selectedVariants={{}}
                    onSubmit={onBookingSubmit}
                />
            )}
        </Card>
    );
}

export default function Pricing({ titulo, subtitulo, productos = [], textoBoton, textoMoneda, tituloCaracteristicas, notaFinal, id }) {
    const ePaycoRef = useRef(null);

    // Handler for when a reservation is completed
    const handleBookingSubmit = async (paymentData, product) => {
        try {
            // 1. Generar referencia única
            const reference = `ORD-${Date.now()}`;

            // 2. Preparar datos para backend con campos en español
            const reservaData = {
                ...paymentData,
                reference, // Actualizar referencia
                producto: product.id, // Numeric ID for backend
                nombreVariante: product.varianteSeleccionada?.nombreVariante || ''
            };

            // Extraer datos de pago antes de enviar al backend
            const paymentAmount = reservaData._paymentData?.amountCop || reservaData.total;

            // Remover datos internos de pago antes de enviar al backend
            const { _paymentData, ...dataParaBackend } = reservaData;

            // 3. Crear reserva en Strapi con estado pendiente
            const response = await crearReserva(dataParaBackend);

            // Validate required fields
            if (!paymentAmount || paymentAmount <= 0) {
                throw new Error(`Invalid payment amount: ${paymentAmount}`);
            }

            if (!paymentData.emailContacto) {
                throw new Error('Email is required for payment');
            }

            if (!paymentData.telefonoContacto) {
                throw new Error('Phone is required for payment');
            }

            const primerPasajero = paymentData.pasajeros?.[0] || {};
            const nombreCliente = primerPasajero.nombres && primerPasajero.apellidos
                ? `${primerPasajero.nombres} ${primerPasajero.apellidos}`
                : paymentData.nombreContacto || 'Cliente';


            const ePaycoData = {
                reference: reference,
                name: product.nombre || 'Producto',
                description: product.descripcion || 'Reserva de producto',
                amount: paymentAmount, // Monto en COP
                email: paymentData.emailContacto,
                customerName: nombreCliente,
                phone: paymentData.telefonoContacto,
                extra1: String(product.id || ''), // ID del producto (convertido a string)
                extra2: String(product.varianteSeleccionada?.id || ''), // ID de la variante (convertido a string)
            };


            await ePaycoRef.current.initiatePayment(ePaycoData);

            // 5. Redirigir a página de confirmación
            //navigate(`/payment-confirmation?ref=${reference}`);

            return response;
        } catch (error) {
            console.error('❌ Error al crear reserva:', error);
            console.error('❌ Error response status:', error.response?.status);
            console.error('❌ Error response data:', error.response?.data);
            console.error('❌ Error message:', error.message);
            throw error;
        }
    };

    return (
        <>
            {/* Start Pricing  */}
            <section className="section bg-primary" id={id || 'pricing'}>
                <Container>
                    <Row className="justify-content-center">
                        <div className="col-12">
                            <div className="section-title text-center mb-4 pb-2">
                                <h4 className="title fw-semibold mb-4 text-white">{titulo || 'Pricing Plans'}</h4>
                                <p className="para-desc text-white mx-auto mb-0">{parseHtml(subtitulo)}</p>
                            </div>
                        </div>
                    </Row>

                    <Row>
                        {productos && productos.length > 0 ? (
                            productos.map((producto, key) => (
                                <Col lg={4} md={6} className="col-12 mt-4 pt-2" key={producto.documentId || key}>
                                    <ProductCard
                                        producto={producto}
                                        textoBoton={textoBoton}
                                        textoMoneda={textoMoneda}
                                        tituloCaracteristicas={tituloCaracteristicas}
                                        allProducts={productos}
                                        onBookingSubmit={handleBookingSubmit}
                                    />
                                </Col>
                            ))
                        ) : (
                            <div className="col text-center">
                                <p className="text-body">No hay productos disponibles</p>
                            </div>
                        )}

                       
                    </Row>
                    <Row>
                    {productos && productos.length > 0 && notaFinal && (
                            <div className="col text-center mt-2">
                                <p className="mt-3 mb-0 text-white">Nota: <span className="text-danger fs-5">*</span>{notaFinal}</p>
                            </div>
                        )}
                        </Row>
                </Container>

                {/* Componente invisible de ePayco */}
                <EPaycoButton
                    ref={ePaycoRef}
                    onPaymentSuccess={() => console.log('Checkout abierto')}
                    onPaymentError={(error) => {
                        console.error('Error al abrir checkout:', error);
                        alert('Error al abrir el checkout de pago');
                    }}
                />
            </section>
        </>
    )
}
